module.exports = __webpack_public_path__ + "img/app-home-screen-light.2a2fa4d2.png";